<template>
    <div class=" knowledgePointsSpeak">
        <div class="w-1280 delFloat">
            <div class="padding commonBackground margin-bottom">
                <span class="font-weight-bold margin-right margin-top">学科:</span>
                <span class="margin-top margin-right cursorSz" :class="subjectId===item.subjectId?'select':''"
                      @click="selectSubject(item.subjectId,item.subjectName)"
                      style="border: none;margin: 10px;margin-right: 5px!important;" v-for="item in subjectList" :key="item.subjectId">
                                        {{item.subjectName}}
                </span>
            </div>
            <!--查看知识点精讲-->
            <div class="float-left">
                <!--左侧栏-->
                <div class="knowledgeTree commonShadow padding-top  public_scroll_bar position-relative" :class="changeGd?'gd':''">
                    <div v-show="!loadingTj">
                        <!--左侧目录-->
                        <div class="padding-small">
                            <div class="elTreeBox public_scroll_bar">
                                <el-tree
                                        class="margin-top"
                                        :data="knowLedgeList"
                                        default-expand-all
                                        node-key="id"
                                        ref="tree"
                                        :highlight-current=true
                                        :props="defaultProps">
                                    <!--嵌套其中的值，scope的data可以获得当前节点的值，这样写实现嵌套效果-->
                                    <div slot-scope="{node,data}" style="width: 180px;">

                                        <div v-if="node.level===1" class="text-ellipsis" :title="data.catgeoryName"  >
                                            {{data.categoryName}}
                                        </div>
                                        <div v-else  @click="selectKnowLedge(data.id)" :title="data.title" class="text-ellipsis" :class="knowLedgeId===data.id?'directoryActive':''">
                                            {{data.title}}
                                        </div>
                                    </div>
                                </el-tree>
                            </div>
                        </div>
                    </div>
                    <loading :show="loadingTj" ></loading>
                </div>
            </div>
            <div class="float-right position-relative rightContent commonShadow">
                <div v-show=" !loadingData" class="  padding commonShadow">
                    <div >
                        <div class="text-l-size font-weight-bolder margin-bottom">知识点总结：</div>
                        <div v-show="summary!==''" v-html="summary" class="text-default-color"></div>
                        <div class="text-center text-l-secondary" v-show="summary===''&&!loadingData">
                            暂无内容
                        </div>
                    </div>
                    <div>
                        <div class="text-l-size font-weight-bolder margin-bottom">常见考法：</div>
                        <div v-show="examWay!==''" class="text-default-color" v-html="examWay"></div>
                        <div class="text-center text-l-secondary" v-show="examWay===''&&!loadingData">
                            暂无内容
                        </div>
                    </div>
                    <div >
                        <div class="text-l-size font-weight-bolder margin-bottom">误区提醒：</div>
                        <div v-show="mistake!==''" class="text-default-color" v-html="mistake"></div>
                        <div class="text-center text-l-secondary" v-show="mistake===''&&!loadingData">
                            暂无内容
                        </div>
                    </div>
                </div>
                <loading :show="loadingData"  ></loading>
            </div>
        </div>

    </div>
</template>

<script>
    import {knowledgeCategory, knowledgePoint, knowledgeSubject} from "../../config";

    export default {
        name: "knowledgePointsSpeak",
        data(){
          return{
              defaultProps: {children: 'knowledgePoints',label: 'name'},
              subjectList:[],
              subjectId:'',
              subjectName:'',
              knowLedgeList:[],
              knowLedgeId:'',
              loadingTj:false,
              currentPage:1,
              totalItem:0,
              loadingData:false,
              /*获取内容知识点总结*/
              summary:'',
              //误区提醒
              mistake:'',
              //常见考法
              examWay:'',
              knowledgeContent:[],
              changeGd:false
          }
        },
        mounted(){
            this.loadingData=true;
          //根据学科id查询知识点分类
            this.searchSubjectList();
            window.onscroll=(()=>{
                if(window.pageYOffset>=80){
                    this.changeGd=true;
                }else if(window.pageYOffset<80){
                    this.changeGd=false;
                }
            })
        },
        methods:{
            handleCurrentChange(){

            },
            //选择知识点
            selectKnowLedge(val){
                this.knowLedgeId=val;
                this.searchKnowledgeContent();
            },
            //选择学科
            selectSubject(valId,valName){
                this.subjectName=valName;
                this.subjectId=valId;
                this.searchKnowledgeCategory();
            },
            //查出知识点学科列表
            async searchSubjectList(){
                this.loadingTj=true;
                let result=await knowledgeSubject();
                if(result.status){
                    this.subjectList=result.data;
                    this.subjectId=result.data[0].subjectId;
                    this.subjectName=result.data[0].subjectName;
                    this.searchKnowledgeCategory();
                }else{
                    this.loadingTj=false;
                }
            },
            //根据学科id查知识点分类
            async searchKnowledgeCategory(){
                let result=await knowledgeCategory(this.subjectId);
                if(result.status){
                    this.loadingTj=false;
                    this.knowLedgeList=result.data;
                    this.knowLedgeId=result.data[0].knowledgePoints[0].id;
                    this.searchKnowledgeContent();
                }
            },
            //根据知识点id查出知识点内容
            async searchKnowledgeContent(){
                this.loadingData=true;
                let result=await knowledgePoint(this.knowLedgeId);
                if(result.status){
                    this.loadingData=false;

                    this.summary=result.data.summary;
                    this.mistake=result.data.mistake;
                    this.examWay=result.data.examWay;

                }else{
                    this.loadingData=false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .knowledgePointsSpeak{

        margin-top: 20px;
        /*与testCenter 627行样式一样，需统一*/
        .rightContent{
            width:980px;
            background: #ffffff;
            min-height: 500px;
        }
        .knowledgeTree.gd{
            position: fixed;
            top:65px;
        }
        .knowledgeTree {
            background: #ffffff;
            width: 280px;
            height: calc(100vh - 134px);
            float: left;
            margin-right: 10px;
            .el-button {
                width: 240px;
                margin: 0 20px;
            }
            .elTreeBox{
                height: calc(100vh - 211px);
                overflow-y: auto;
            }
        }
    }
</style>
